import AuthService from './AuthService';

export default {
    canAccessActivities() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    canAccessAllTimesheets() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    canAccessTimeClock() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    canAccessCompanySettings() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    canAccessTeam() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    canAccessSubscriptions() {
        if(AuthService.getUser() !== null) {
            return AuthService.getUser().role_id < 3;
        }
        return false;
    },
    getPermissions(user, ownerId, companySettings) {
        return {
            canAccessActivity: user.role_id < 3,
            canAccessAllTimesheets: user.role_id < 3,
            canAccessBilling: user.id === ownerId,
            canAccessSettings: user.role_id < 2,
            canAccessManageTeam: user.role_id < 3,
            canManageEntries: this.canManageEntries(user, ownerId, companySettings)
        }
    },
    canManageEntries(user, ownerId, companySettings) {

        if(user.id === ownerId) {
            return true;
        }
        if(user.role_id === 1 && companySettings.manage_entries_admin) {
            return true;
        }
        if(user.role_id === 2 && companySettings.manage_entries_manager) {
            return true;
        }
        if(user.role_id === 3 && companySettings.manage_entries_employee) {
            return true;
        }

        return false;
    }
}